import React, {
  FunctionComponent,
  DetailedHTMLProps,
  ButtonHTMLAttributes,
} from 'react'
import Loader from './loader'

export interface Props
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  isLoading?: boolean
}

const LoaderButton: FunctionComponent<Props> = ({
  isLoading = false,
  children,
  ...buttonProps
}) => (
  <button type="submit" {...buttonProps}>
    {isLoading ? (
      <Loader className="loader--button" isLoading={isLoading} />
    ) : (
      children
    )}
  </button>
)

export default LoaderButton
